export const PiratInViaggioRoutes = [
  {
    path: '/italia',
    name: 'italia',
    component: () =>
      import(
        /* webpackChunkName: "lp-piratinviaggio" */ /* webpackPreload: true */ '../views/Landingpages/PiratInViaggio/Italia.vue'
      ),
    meta: {
      breadcrumb: 'Italia',
    },
  },
]
